export const MAIN_CLASS_NAME = 'agent-card';
export const DISABLED_CLASS_NAME = `${MAIN_CLASS_NAME}_disabled`;
export const EXTRA_CLASS_NAME = `${MAIN_CLASS_NAME}__extra`;
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const INSTRUCTIONS_CLASS_NAME = `${CONTENT_CLASS_NAME}__instructions`;
export const TOOLSET_LIST_CLASS_NAME = `${CONTENT_CLASS_NAME}__toolset-list`;
export const TOOLSET_LIST_ITEM_CLASS_NAME = `${TOOLSET_LIST_CLASS_NAME}__item`;
export const FOOTER_CLASS_NAME = `${MAIN_CLASS_NAME}__footer`;
export const TOOLTIP_CLASS_NAME = `${MAIN_CLASS_NAME}__tooltip`;

export const TOOLSETS_PAGE_SIZE = 4;

export const TRANSLATION_GROUP_PREFIX = 'Agent: Card:';
